module.exports = __webpack_public_path__ + "img/connect.419fbbaa.jpeg";